import {Box} from '../generated/model/models'

export class Box2 implements Box {
  width: number
  length: number
  height: number
  frontLength: number
  sideLength: number

  constructor (box: Box) {
    this.width = box.width!
    this.length = box.length!
    this.height = box.height!
    this.frontLength = box.width!
    this.sideLength = box.length!
  }

  setShortSideLeading () {
    this.frontLength = this.width
    this.sideLength = this.length
  }

  setLongSideLeading () {
    this.frontLength = this.length
    this.sideLength = this.width
  }
}

